Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useStyles = void 0;

var styles_1 = require("@material-ui/core/styles");

var useSpacingFromStyleProp_1 = require("../../hooks/useSpacingFromStyleProp");

exports.useStyles = styles_1.makeStyles(function (theme) {
  return styles_1.createStyles({
    root: function root(props) {
      return {
        marginBottom: useSpacingFromStyleProp_1.getSpacingFromStyleProp({
          props: props,
          stylePropName: "marginBottom",
          theme: theme
        }),
        marginLeft: useSpacingFromStyleProp_1.getSpacingFromStyleProp({
          props: props,
          stylePropName: "marginLeft",
          theme: theme
        }),
        marginRight: useSpacingFromStyleProp_1.getSpacingFromStyleProp({
          props: props,
          stylePropName: "marginRight",
          theme: theme
        }),
        marginTop: useSpacingFromStyleProp_1.getSpacingFromStyleProp({
          props: props,
          stylePropName: "marginTop",
          theme: theme
        }),
        paddingBottom: useSpacingFromStyleProp_1.getSpacingFromStyleProp({
          props: props,
          stylePropName: "paddingBottom",
          theme: theme
        }),
        paddingLeft: useSpacingFromStyleProp_1.getSpacingFromStyleProp({
          props: props,
          stylePropName: "paddingLeft",
          theme: theme
        }),
        paddingRight: useSpacingFromStyleProp_1.getSpacingFromStyleProp({
          props: props,
          stylePropName: "paddingRight",
          theme: theme
        }),
        paddingTop: useSpacingFromStyleProp_1.getSpacingFromStyleProp({
          props: props,
          stylePropName: "paddingTop",
          theme: theme
        })
      };
    }
  });
}, {
  name: "NatDSSpacing"
});